// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1jW2_","footer":"ReportModalFilter_footer__27nCr"};